import queryStringParams from './queryStringParams';
export default queryStringParams;



// WEBPACK FOOTER //
// ./src/services/queryStringParams/index.js